module.exports = __webpack_public_path__ + "static/img/circel_01_m.a512781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circel_01_m.png
// module id = lBdO
// module chunks = 1